import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AllPlans } from "./AllPlans";
import { RazorpayButtonPage } from "./RazorpayButtonPage";
import { useBranding } from "../../contexts/branding";
import NoMatch from "../../components/no-match";
import SubscriptionActivationPending from "./SubscriptionActivationPending";

export default function IndiaPaymentPage() {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    const search = new URLSearchParams(location.search);
    const planId = search.get("plan_id") || "";
    const jotformId = search.get("jotform_id") || "";
    const userId = search.get("user_id") || "";
    const paymentButtonId = search.get("payment_button_id") || "";
    const rcPlan = search.get("rc_plan") || "";
    const fromMobile = search.get("fromMobile") === "true";
    const { label, logoUrl } = useBranding();
    const { pathname } = location;

    let content;
    if (pathname.endsWith("/subscription-activation-pending")) {
        content = <SubscriptionActivationPending />;
    } else if (paymentButtonId) {
        content = <RazorpayButtonPage paymentButtonId={paymentButtonId} />;
    } else if (planId || jotformId || userId) {
        content = (
            <AllPlans
                jotformId={jotformId}
                rcPlan={rcPlan}
                userId={userId}
                fromMobile={fromMobile}
            />
        );
    } else if (!jotformId && !userId) {
        content = <NoMatch />;
    }

    return (
        <>
            <div className="payment-header">
                <img src={logoUrl} alt={label} />
            </div>
            <div className="payment-content-bg">{content}</div>
        </>
    );
}
